export default __webpack_public_path__ + "static/media/challenges1.39f59e02.jpg";